(function() {
  'use strict';

  // ---- Guard: GSAP must be loaded ----
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('[LMT] GSAP not loaded - animations disabled');
    // Make all hidden elements visible as fallback
    document.querySelectorAll('.lmt-hero-headline, .lmt-hero-subheading, .lmt-hero-cta, [id="hero-scroll-indicator"]')
      .forEach(function(el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    document.querySelectorAll('.lmt-reveal')
      .forEach(function(el) {
        el.classList.add('is-visible');
      });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // ---- Scroll Reveal (CSS fallback + enhancement) ----
  var revealElements = document.querySelectorAll('.lmt-reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });
    revealElements.forEach(function(el) { revealObserver.observe(el); });
  } else {
    revealElements.forEach(function(el) { el.classList.add('is-visible'); });
  }

  // ---- Staggered transition delays ----
  document.querySelectorAll('[data-stagger]').forEach(function(container) {
    container.querySelectorAll('.lmt-reveal').forEach(function(child, index) {
      child.style.transitionDelay = (index * 0.08) + 's';
    });
  });

  // ---- Navigation scroll effect ----
  var nav = document.querySelector('.lmt-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 50) {
        nav.classList.add('lmt-nav--scrolled');
      } else {
        nav.classList.remove('lmt-nav--scrolled');
      }
    }, { passive: true });
  }

  // ---- Mobile drawer ----
  var menuBtn = document.querySelector('[data-menu-open]');
  var drawer = document.querySelector('.lmt-drawer');
  var backdrop = document.querySelector('.lmt-drawer__backdrop');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuBtn) menuBtn.addEventListener('click', openDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);
  if (drawer) {
    var closeBtn = drawer.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeDrawer);
    });
  }

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href && href !== '#') {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  // ---- Hero zoom animation ----
  var heroZoom = document.querySelector('.lmt-hero__zoom');
  var heroContent = document.querySelector('.lmt-hero__content');

  if (heroZoom) {
    var tl = gsap.timeline();

    tl.set(heroZoom, { scale: 2.5 })
      .to(heroZoom, {
        scale: 1,
        duration: 2.8,
        ease: 'power2.inOut',
        delay: 0.1
      });

    if (heroContent) {
      var headlineLines = heroContent.querySelectorAll('.lmt-hero-headline');
      var subheading = heroContent.querySelector('.lmt-hero-subheading');
      var ctas = heroContent.querySelectorAll('.lmt-hero-cta');
      var scrollIndicator = document.getElementById('hero-scroll-indicator');

      if (headlineLines.length) {
        tl.to(headlineLines, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          stagger: 0.15
        }, '-=0.6');
      }

      if (subheading) {
        tl.to(subheading, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out'
        }, '-=0.7');
      }

      if (ctas.length) {
        tl.to(ctas, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: 'power3.out',
          stagger: 0.1
        }, '-=0.6');
      }

      if (scrollIndicator) {
        tl.to(scrollIndicator, {
          opacity: 1,
          duration: 0.3,
          ease: 'power2.out'
        }, '-=0.3');
      }
    }
  }

  // ---- GSAP Scroll-driven section animations ----

  // Section headers
  gsap.utils.toArray('.lmt-animate-header').forEach(function(header) {
    gsap.from(header.children, {
      y: 40,
      opacity: 0,
      duration: 0.7,
      ease: 'power2.out',
      stagger: 0.1,
      scrollTrigger: {
        trigger: header,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Feature items
  gsap.utils.toArray('.lmt-animate-features').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-item'), {
      x: -20,
      opacity: 0,
      duration: 0.5,
      ease: 'power2.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: container,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Service / process cards
  gsap.utils.toArray('.lmt-animate-cards').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-card'), {
      x: 30,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.out',
      stagger: 0.15,
      scrollTrigger: {
        trigger: container,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Category cards
  gsap.utils.toArray('.lmt-animate-categories').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-category'), {
      y: 60,
      opacity: 0,
      scale: 0.96,
      duration: 0.8,
      ease: 'power2.out',
      stagger: 0.1,
      scrollTrigger: {
        trigger: container,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Step cards
  gsap.utils.toArray('.lmt-animate-steps').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-step'), {
      y: 50,
      opacity: 0,
      duration: 0.7,
      ease: 'power2.out',
      stagger: 0.15,
      scrollTrigger: {
        trigger: container,
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Social cards
  gsap.utils.toArray('.lmt-animate-social').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-social-card'), {
      y: 40,
      opacity: 0,
      scale: 0.97,
      duration: 0.6,
      ease: 'power2.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: container,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Product cards
  gsap.utils.toArray('.lmt-animate-products').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-product'), {
      y: 40,
      opacity: 0,
      duration: 0.6,
      ease: 'power2.out',
      stagger: 0.08,
      scrollTrigger: {
        trigger: container,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });

  // Form fields
  gsap.utils.toArray('.lmt-animate-form').forEach(function(container) {
    gsap.from(container.querySelectorAll('.lmt-animate-field'), {
      y: 15,
      opacity: 0,
      duration: 0.4,
      ease: 'power2.out',
      stagger: 0.05,
      scrollTrigger: {
        trigger: container,
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    });
  });

  // ---- Testimonial slider ----
  var sliderContainer = document.querySelector('[data-testimonial-slider]');
  if (sliderContainer) {
    var track = sliderContainer.querySelector('.lmt-slider-track');
    var prevBtn = sliderContainer.querySelector('[data-slider-prev]');
    var nextBtn = sliderContainer.querySelector('[data-slider-next]');
    var dots = sliderContainer.querySelectorAll('[data-slider-dot]');

    if (track && track.children.length) {
      var currentIndex = 0;
      var cardsPerView = window.innerWidth >= 1024 ? 3 : 1;
      var maxIndex = Math.max(0, track.children.length - cardsPerView);

      function updateSlider() {
        var cardWidth = track.children[0].getBoundingClientRect().width + 24;
        track.style.transform = 'translateX(-' + (currentIndex * cardWidth) + 'px)';
        dots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === currentIndex);
        });
        if (prevBtn) prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '1';
        if (nextBtn) nextBtn.style.opacity = currentIndex >= maxIndex ? '0.3' : '1';
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          if (currentIndex > 0) { currentIndex--; updateSlider(); }
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          if (currentIndex < maxIndex) { currentIndex++; updateSlider(); }
        });
      }
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          currentIndex = Math.min(i, maxIndex);
          updateSlider();
        });
      });

      updateSlider();
      window.addEventListener('resize', updateSlider, { passive: true });
    }
  }

})();
